import Container from "components/general/Container";
import ScrollContainer from "components/general/ScrollContainer";
import SitesHeader from "components/sites/SitesHeader";
import { H1 } from "components/ui";
import React from "react";

export default function Page() {
	return (
		<ScrollContainer>
			<SitesHeader />
			<Container>
				<H1>Feedback</H1>
			</Container>
		</ScrollContainer>
	);
}
